import { Directive } from '@angular/core';

@Directive({
  selector: '[libContainerPalletForm]'
})
export class ContainerPalletFormDirective {}
